import { cn } from "@onclicks/sharedcomponents/ui";
import React, { forwardRef, TextareaHTMLAttributes } from "react";
import Icon from "../shared/ui/icon";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  titre: string;
  icon?: string;
  error?: string;
  description?: string;
  containerClassName?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      titre,
      icon,
      error,
      description,
      containerClassName,
      className,
      ...props
    },
    ref,
  ) => {
    const id = props.id || `textarea-${props.name}`;

    return (
      <div className={cn("space-y-2", containerClassName)}>
        <label
          htmlFor={id}
          className="text-sm font-semibold text-slate-600 dark:text-white"
        >
          {titre}
        </label>

        <div className="relative">
          {icon && (
            <div className="absolute top-3 left-0 flex items-start pl-3 pointer-events-none">
              <Icon name={icon} className="text-lg text-slate-400" />
            </div>
          )}

          <textarea
            {...props}
            ref={ref}
            id={id}
            aria-invalid={!!error}
            className={cn(
              "w-full bg-slate-50 rounded-lg p-3",
              "border-1 border-slate-200 dark:border-slate-300 text-slate-800",
              "transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary",
              "resize-y min-h-[100px]",
              error && "ring-2 ring-red-500",
              icon && "pl-10",
              className,
            )}
          />
        </div>

        {description && !error && (
          <p className="text-xs text-slate-500 italic">{description}</p>
        )}
        {error && <p className="text-xs text-red-600 font-medium">{error}</p>}
      </div>
    );
  },
);

Textarea.displayName = "Textarea";
